module.exports = __webpack_public_path__ + "static/telephone-72024bb3d53435094e11caffcbbd7d3a.svg";